import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {forkJoin} from 'rxjs';
import {FormlyFieldSelect} from './../../Core/Abstract/CustomFormlyTemplate/formly-field-select';
import {AdminClustersService} from './adminClusters.service';

@Component({
  selector: 'adminClusters-grid',
  templateUrl: './adminClusters.component.html',
  providers: [AdminClustersService, FormlyFieldSelect],
})
export class AdminClustersComponent extends BaseGridNoCookieComponent<AdminClustersService> implements AfterViewInit{
  @ViewChild('confirmModal')
  public confirmModal: ModalDirective;
  @ViewChild('confirmDeleteModal')
  public confirmDeleteModal: ModalDirective;
  fourEyes: boolean = false;
  fourEyesRequestId: string = '';
  foureyesComparisonId: number;
  public submiting: boolean = false;
  debtorForm: UntypedFormGroup;
  clusters = [];
  loadingForm: boolean = false;
  cluster: any;
  debtorId: any;
  productCodes = [];
  viewRole: any;
  isSubmitted = false;
  isDebtorChecked = false;
  isBuyerCheck = false;
  isSupplierCheck = false;
  clusterCannotBeAltered: boolean = false;
  isBothCheck = false;
  supplierPer: any;
  buyerPer: any;
  checkboxErrorMsg: any;
  checkboxError = false;
  prntValueFrom: any;
  prntValueTo: any;
  prepaymentPrntDf: any;
  fundingPrntErrorMsg: any;
  paidBuyErrMsg: any;
  paidSupErrMsg: any;
  form: any;
  options: FormlyFormOptions = {};
  model: any;
  fields: FormlyFieldConfig[];
  termsAndConditionList = [];
  clusterId: number;
  actionStatus: String;
  clusterCode: String;
  modalClusterId: number;
  tagName: string;
  isCollapsed: boolean = true;
  constructor(
    public gridService: AdminClustersService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
    elem: ElementRef
  ) {
    super(securityService, logger, visualsService, gridService, 'newCluster');
    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.viewRole = this.securityService.isOtherStaff();
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
    this.eventsEmitterService.languageChange.subscribe({
      next: () => {
        this.loadVisuals();
      },
    });
    this.getProductList();
    this.loadVisuals();
    this.buildDebtorForm();
  }

  ngAfterViewInit() {
    if (this.fourEyes && this.foureyesComparisonId != null) {
      this.updateCluster(this.foureyesComparisonId);
    } else if (this.fourEyes && this.foureyesComparisonId == null) {
      this.openNewModal();
    }
  }

  getFormConfigAndData(clusterId) {
    this.loadingForm = true;
    this.clusterCannotBeAltered = this.fourEyes || this.clusterCannotBeAltered;
    forkJoin([
      this.gridService.getFields(this.fourEyes, this.fourEyesRequestId),
      this.gridService.getClusterById(clusterId),
      this.gridService.getTermsAndConditionsListWithoutBlobs(),
      this.gridService.get4eyesRequest(this.fourEyesRequestId)
    ]).subscribe({
      next: (response) => {
        let arrayToObject = !this.fourEyes? JSON.parse(response[1].data.dataChar) : JSON.parse(response[3].data.oldJsonRec);
        let arrayToObject2 = this.isIterable(arrayToObject) ? {...arrayToObject} : arrayToObject;
        this.model = Object.assign({}, arrayToObject2);
        if (this.clusterCannotBeAltered) {
          this.model = {...this.model, disableForm: true};
        }
        this.termsAndConditionList = response[2].data;
        let {fields, options} = this.mapFields(JSON.parse(response[0].data.valForm));
        this.fields = fields;
        this.options = options;
        this.form = new UntypedFormArray(this.fields.map(() => new UntypedFormGroup({})));
        this.loadingForm = false;
      },
      error: (error) => console.log('Error: ', error),
      complete: () => {
        this.loadingForm = false;
      },
    });
  }

  buildDebtorForm() {
    this.debtorForm = this.fb.group({
      debtorId: [null, [Validators.required, Validators.maxLength(10)]],
    });
  }

  updateCluster(id: number) {
    this.clusterId = id;
    this.actionStatus = 'update';
    this.checkCluster(id);
    if (!this.fourEyes) {
      this.confirmModal.show();
    }
  }

  getClusterList() {
    this.loading = true;
    this.gridService.getClusterList(this.debtorId).subscribe({
      next: (res) => {
        this.clusters = res.data;
        this.loading = false;
      },
      error: (error) => {
        this.clusters = [];
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  getProductList() {
    this.gridService.getProductCodeList().subscribe({
      next: (data) => {
        this.productCodes = data.data;
      },
      error: (error) => {
        this.productCodes = [];
        this.logger.info(error);
      },
    });
  }

  clearDebtorList() {
    this.debtorId = null;
    this.isDebtorChecked = false;
    this.debtorForm.reset();
    this.clusters = [];
  }

  searchClusters() {
    this.debtorId = this.debtorForm.controls.debtorId.value;
    if (this.debtorId == '' || this.debtorId == null) {
      LogService.emitAlert({
        type: 'info',
        body: 'You need to choose Buyer first',
      });
    } else {
      this.getClusterList();
    }
  }

  openNewModal() {
    this.actionStatus = 'create';
    this.debtorId = this.debtorForm.get('debtorId').value;
    this.clusterId = null;
    if (!this.fourEyes) {
      if (this.debtorId == '' || this.debtorId == null) {
        LogService.emitAlert({
          type: 'info',
          body: 'You need to choose a Buyer first',
        });
        return;
      }
      this.loadingForm = true;
      this.loading = true;

      forkJoin([
        this.gridService.checkDebtorId(this.debtorId),
        this.gridService.getFields(this.fourEyes, this.fourEyesRequestId),
        this.gridService.getInitData(this.debtorId),
        this.gridService.getTermsAndConditionsListWithoutBlobs()
      ]).subscribe({
        next: (response) => {
          this.isSubmitted = false;
          this.termsAndConditionList = response[3].data;
          this.confirmModal.show();
          this.clusterCannotBeAltered = false;
          this.loadingForm = true;

          this.clusterCode = response[2].data ? response[2].data.code : null;
          this.model = {disableForm: false};
          let {fields, options} = this.mapFields(JSON.parse(response[1].data.valForm));
          this.fields = fields;
          this.options = options;
          this.form = new UntypedFormArray(this.fields.map(() => new UntypedFormGroup({})));
          this.loadingForm = false;
          this.loading = false;
          setTimeout(() => {
            this.form.controls[0].get('code').setValue(this.clusterCode);
          }, 100);
        },
        error: (error) => {
          console.log('Error: ', error);
        },
        complete: () => {
          this.loadingForm = false;
          this.loading = false;
        },
      });
    } else {
      this.loadingForm = true;

      forkJoin([this.gridService.getFields(this.fourEyes, this.fourEyesRequestId)]).subscribe(
        (response) => {
          this.isSubmitted = false;
          this.clusterCannotBeAltered = true;
          this.loadingForm = true;

          this.model = {disableForm: true};
          let {fields, options} = this.mapFields(JSON.parse(response[0].data.valForm));
          this.fields = fields;
          this.options = options;
          this.form = new UntypedFormArray(this.fields.map(() => new UntypedFormGroup({})));
          this.loadingForm = false;
          setTimeout(() => {
            this.form.controls[0].get('code').setValue(this.clusterCode);
          }, 100);
        },
        (error) => {
          console.log('Error: ', error);
          this.loadingForm = false;
        },
      );
    }
  }

  checkCluster(id: number) {
    this.loadingForm = true;
    this.gridService.checkCluster(id).subscribe({
      next: () => {
        this.loadingForm = false;
        this.clusterCannotBeAltered = false;
        if (this.actionStatus == 'delete') {
          this.deleteCluster(id);
        } else {
          this.getFormConfigAndData(id);
        }
      },
      error: (error) => {
        this.clusterCannotBeAltered = true;
        this.loadingForm = false;
        this.getFormConfigAndData(id);
        this.confirmDeleteModal.hide();
      },
      complete: () => {
        this.confirmDeleteModal.hide();
      },
    });
  }
  deleteCluster(id: number) {
    this.loading = true;
    this.gridService.deleteCl(id).subscribe({
      next: (data) => {
        this.loading = false;
        LogService.emitAlert({
          type: 'success',
          body: data.message,
        });
        this.getClusterList();
      },
      error: (error) => {
        this.confirmDeleteModal.hide();
        this.logger.info(error);
        console.log(error);
        if (!error.success) {
          LogService.emitAlert({
            type: 'warn',
            body: error.message,
          });
        }
        this.loading = false;
      },
    });
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.actionStatus == 'create') {
      this.gridService.checkClusterCode(this.form.value[0].code, this.debtorId).subscribe({
        next: (response) => {
          console.log('Check cluster res: ', response);
          if (response.success == false) {
            LogService.emitAlert({
              type: 'danger',
              body: response.message,
            });
            this.loading = false;
          } else {
            if (this.form.invalid) {
              this.loading = false;
              return;
            } else {
              this.save();
            }
          }
        },
        error: (error) => {
          this.logger.info(error);
          this.loading = false;
        },
      });
    } else if (this.actionStatus == 'update') {
      if (this.form.invalid) {
        this.loading = false;
        return;
      } else {
        this.save();
      }
    }
  }
  save() {
    this.loading = true;
    let formToSend = Object.assign({}, ...this.form.getRawValue());
    formToSend['debtorId'] = this.debtorId;
    formToSend['id'] = this.clusterId;
    formToSend['dataChar'] = JSON.stringify(formToSend);
    this.gridService.addCluster(formToSend).subscribe({
      next: (data) => {
        this.getClusterList();
        LogService.emitAlert({
          type: 'success',
          body: data.message,
        });
        this.isSubmitted = false;
        this.loading = false;
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
    this.confirmModal.hide();
  }
  public valueChanged(modalname: string, value: any) {
    this.debtorId = value.dbtrId;
    this.isDebtorChecked = false;
    this.debtorForm.controls['debtorId'].setValue(this.debtorId);
  }

  getPrefillFields() {
    let formToSend = Object.assign({}, ...this.form.value);
    let productCodeCurrent = formToSend['productCode'];

    // this.productCodeSpinner = true;
    this.gridService.getPercentageValues(productCodeCurrent).subscribe({
      next: (res) => {
        this.prntValueFrom = res.data.valueFrom;
        this.prntValueTo = res.data.valueTo;
        // this.form.controls[0].controls.fundingPercentage.setValue(data.data.valueDef);
      },
      error: (error) => {
        this.logger.info(error);
      },
    });

    this.gridService.getPrefillFields(productCodeCurrent).subscribe({
      next: (data) => {
        if (data.data) {
          this.form.controls[0].controls.productType.setValue(data.data.productType);
          setTimeout(() => {
            this.form.controls[0].get('fundingPercentage').setValue(data.data.fundingLimit);
            this.form.controls[0].get('autoDebitBuyer').setValue(data.data.autoDebitBuyer);
            this.form.controls[0].get('payAtMaturity').setValue(data.data.payAtMaturity);
            this.form.controls[0]
              .get('groupingOfSettlement')
              .setValue(data.data.groupingOfSettlement);
            this.form.controls[0].get('autoAllocation').setValue(data.data.autoAllocation);
            this.form.controls[0].get('ddModel').setValue(data.data.ddModel);
            this.form.controls[0].get('ddBidEnabled').setValue(data.data.ddBidEnabled);
            this.form.controls[0]
              .get('ddAutoEligibleForDd')
              .setValue(data.data.ddAutoEligibleForDd);
          }, 100);
        }
      },
      error: (error) => {
        this.logger.info(error);
      },
    });
  }

  getBenchmarkFlow(interestRuleCode: any) {
    localStorage.setItem('interestRuleCode', interestRuleCode);
    if (this.form.controls[0].controls.benchmarkRate)
      this.form.controls[0].controls.benchmarkRate.setValue(null);
    if (this.form.controls[0].controls.interestTypeReferenceId)
      this.form.controls[0].controls.interestTypeReferenceId.setValue(null);
  }

  clearFields(fieldsString: any) {
    let fields = fieldsString.split(',');
    fields.forEach((field) => {
      if (this.form.controls[0].controls[field])
        this.form.controls[0].controls[field].setValue(null);
    });
  }

  openDeleteModal(clusterId: number) {
    this.modalClusterId = clusterId;
    this.confirmDeleteModal.show();
  }
}
